// extracted by mini-css-extract-plugin
export default {"form":"PlatformForm_form__wztzl","error":"PlatformForm_error__rdpjV"};